import { get, GetReturnType, post } from "src/api/fetch";
import { getSchemaFromUrl } from "src/router/routes";
import { Type_User } from "src/types/user";

export const login = (body: Omit<Type_User, "id">): GetReturnType => {
    return post(body, `${VITE_API_URL}/${getSchemaFromUrl()}/auth/login`);
};

export const isTokenValid = (token: string): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/auth/validate`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export const logout = (token: string): GetReturnType => {
    return post({}, `${VITE_API_URL}/${getSchemaFromUrl()}/auth/login`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};
